export enum OfficeSettings {
  NOTIFY_PER_INVOICE = "NOTIFY_PER_INVOICE",
  NOTIFY_OUTSTANDING_INVOICE = "NOTIFY_OUTSTANDING_INVOICE",
}
